import { api } from './api';

export interface SignerInboxItem {
  documentId: string;
  documentTitle: string;
  signerStatus: string;
  signatureType: number;
  signedAt?: string | null;
  updatedAt: string;
}

export async function getMySignatureInbox(): Promise<SignerInboxItem[]> {
  const { data } = await api.get<SignerInboxItem[]>('/public/sign/inbox');
  return data;
}
